import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';

import Sun from '../../../../images/onboarding/sunny.svg';
import Moon from '../../../../images/onboarding/moon.svg';

const errorStyles = {
  color: '#f44336',
  fontSize: '12px',
  fontWeight: '600',
  letterSpacing: '0.1px',
};

const GeneralAvailability = ({
  value = [],
  onChange = () => {},
  error = null,
}) => {
  const availableTimes = [
    'weekdays_day',
    'weekdays_night',
    'weekends_day',
    'weekends_night',
  ];

  const handleChange = (event, checkboxValue) => {
    let newValue = [...value];
    if (event.target.checked) {
      newValue.push(checkboxValue);
    } else {
      newValue = newValue.filter(v => v !== checkboxValue);
    }
    onChange(newValue);
  };

  return (
    <div className="general-availability">
      <Sun />
      <Moon />

      <div className="general-availability-row">
        <span>
          <FormattedMessage defaultMessage="MON-FRI" />
        </span>
        {_.map(availableTimes.slice(0, 2), (time, i) => (
          <div key={i}>
            <input
              type="checkbox"
              name={`general-availability-${i}`}
              value={time}
              checked={value.includes(time)}
              onChange={event => handleChange(event, time)}
            />
            <div className="checkbox-svg" />
          </div>
        ))}
      </div>

      <div className="general-availability-row">
        <span>
          <FormattedMessage defaultMessage="SAT-SUN" />
        </span>
        {_.map(availableTimes.slice(2), (time, i) => (
          <div key={i}>
            <input
              type="checkbox"
              name={`general-availability-weekend-${i}`}
              value={time}
              checked={value.includes(time)}
              onChange={event => handleChange(event, time)}
            />
            <div className="checkbox-svg" />
          </div>
        ))}
      </div>

      {error && <p style={errorStyles}>{error}</p>}
    </div>
  );
};

GeneralAvailability.propTypes = {
  value: PropTypes.array, // array of selected values
  onChange: PropTypes.func, // called with updated array
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object, // can be <FormattedMessage />
  ]),
};

export default GeneralAvailability;
